<!--
 * @Description:
 * @Author: lz
 * @Date: 2021-09-06 11:33:38
 * @LastEditTime: 2021-11-19 16:48:06
 * @LastEditors: Please set LastEditors
-->
<template>
  <a-layout id="components-layout-demo-fixed-sider">
    <a-layout-header class="layout-header cr-bg-primary cr-jc-between">
      <div @click="goHome" class="logo" :class="collapsed ? 'isCollapsed' : ''">
        <svg-icon class="icon" icon-class="logo"></svg-icon>
        <h1 v-if="!collapsed">版权工作台</h1>
      </div>
      <div class="cr-user cr-flex">
        <div class="yf" @click="gotoHb">访问蜂擎云服</div>
        <a-badge class="bells" :count="count" :overflow-count="999" :offset="['6', '']" :numberStyle="getStyle">
          <svg-icon class="icon" icon-class="bells" @click="gotoMess"></svg-icon>
        </a-badge>

        <a-dropdown v-model="visible" class="cr-flex cr-in-block" style="vertical-align: middle" v-if="userInfo && userInfo.orgList.length > 0">
          <a class="ant-dropdown-link cr-ai-center user-name cr-fs-lg cr-text-black-1" @click="(e) => e.preventDefault()" style="text-decoration: none; color: inherit">
            <span class="img cr-ai-center">
              <img v-if="userInfo.avatar" :src="userInfo.avatar" style="width: 32px; height: 32px; border-radius: 50%" />
              <svg-icon v-else class="avatar" icon-class="head" style="width: 32px; height: 32px"></svg-icon>
            </span>

            <div class="users-box" :style="getUsersBoxWidth()">
              <div class="user" style="width: 100%; height: 50%; position: relative">
                <span class="cr-fs-ellipsis" :title="userInfo.nickName">{{ userInfo.nickName }}</span>
                <svg-icon class="super" v-if="userInfo.orgList && userInfo.orgList[0].role == 0" icon-class="super"></svg-icon>
                <svg-icon class="manger" v-if="userInfo.orgList && userInfo.orgList[0].role == 1" icon-class="manger"></svg-icon>
                <svg-icon class="member" v-if="userInfo.orgList && userInfo.orgList[0].role == 2" icon-class="personnel"></svg-icon>
              </div>
              <div class="user" style="width: 100%; height: 50%; position: relative">
                <span class="user-gs" v-if="userInfo.orgList && userInfo.orgList.length > 0">{{ userInfo.orgList[0].organizationName }}</span>
              </div>
            </div>
            <a-icon class="cr-in-block cr-text-white-1 cr-ml-1" style="line-height: 50px; padding-top: 4px" type="down" />
          </a>
          <a-menu slot="overlay" style="width: 240px; height: 236px; border-bottom: 1px solid #ccc; font-size: 14px; padding: 0">
            <a-menu-item style="height: 60px" class="menu-item">
              <svg-icon class="bg" icon-class="head-bg"></svg-icon>
              <span class="img" style="margin-right: 10px; display: flex; align-items: center">
                <img v-if="userInfo && userInfo.avatar" :src="userInfo.avatar" style="width: 32px; height: 32px; border-radius: 50%; vertical-align: middle" />
                <svg-icon v-else icon-class="head" style="width: 32px; height: 32px"></svg-icon>
              </span>
              <div style="color: #fff; font-weight: 500">
                <div style="height: 50%; line-height: 30px" class="cr-ai-center">
                  <span style="font-size: 14px; font-weight: 500; margin-right: 5px; color: #fff">{{ userInfo.nickName }}</span>
                  <svg-icon class="super" v-if="userInfo.orgList && userInfo.orgList[0].role == 0" icon-class="super"></svg-icon>
                  <svg-icon class="manger" v-if="userInfo.orgList && userInfo.orgList[0].role == 1" icon-class="manger"></svg-icon>
                  <svg-icon class="member" v-if="userInfo.orgList && userInfo.orgList[0].role == 2" icon-class="personnel"></svg-icon>
                </div>
                <div style="height: 50%; line-height: 30px">
                  <span v-if="userInfo.orgList && userInfo.orgList.length > 0" style="font-size: 12px; font-weight: 400; font-family: PingFangSC-Regular, PingFang SC; color: rgba(255, 255, 255, 0.7)">{{ userInfo.orgList[0].organizationName || '' }}</span>
                </div>
              </div>
            </a-menu-item>
            <a-sub-menu class="submenu" style="border: 1px solid #eee" key="test" v-if="userInfo.orgList && userInfo.orgList.length > 0" title="切换团队">
              <a-menu-item class="drop-box" v-for="(item, index) in userInfo.orgList" :key="index" @click="changeOrganization(item.organizationId)">
                <div class="borders"></div>
                <div style="height: 50%; line-height: 1">
                  {{ item.organizationName }}
                </div>
                <div style="height: 50%; line-height: 1">
                  <svg-icon class="super" style="margin-left: 0" v-if="item.role == 0" icon-class="super"></svg-icon>
                  <svg-icon class="manger" style="margin-left: 0" v-if="item.role == 1" icon-class="manger"> </svg-icon>
                  <svg-icon class="member" style="margin-left: 0" v-if="item.role == 2" icon-class="personnel"> </svg-icon>
                </div>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item style="border-left: 1px solid #eee; border-right: 1px solid #eee" @click="gotoInfo">账号中心</a-menu-item>
            <a-menu-item style="border: 1px solid #eee" @click="gotoEnt" v-show="userInfo.orgList.length > 0 && userInfo.orgList[0].role != 2"> 团队中心</a-menu-item>
            <a-menu-item style="border-left: 1px solid #eee; border-right: 1px solid #eee" @click="handleMenuClick">退出登录</a-menu-item>
          </a-menu>
        </a-dropdown>
        <a class="yf" v-else :href="hbHref" target="_self" rel="noopener noreferrer">登录</a>
      </div>
    </a-layout-header>
    <a-layout class="layout" :class="collapsed ? 'layout-collapsed' : ''">
      <a-layout-sider class="layout-sider" v-model="collapsed" :trigger="null" collapsible>
        <Menus />
        <a-layout-footer>
          <svg-icon class="trigger cr-fs-xl cr-cursor" :icon-class="collapsed ? 'toggle-right' : 'toggle-left'" @click="() => (collapsed = !collapsed)" />
        </a-layout-footer>
      </a-layout-sider>
      <a-layout-content class="layout-content">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Menus from './Menus.vue'
import { getProcessEnv } from '@/utils'
import { removeToken, getRoutePath } from '@/utils/auth'
import { changeOrg, logOut } from '@/api/user'
export default {
  data() {
    return {
      collapsed: false,
      visible: false
    }
  },
  methods: {
    goHome() {
      this.$router.push('/copyright/software')
    },
    getUsersBoxWidth() {
      let length = this.userInfo && this.userInfo.nickName && this.userInfo.nickName.length > 0 ? this.userInfo.nickName.length : 1
      return `max-width: calc(25px*${length});`
    },
    gotoHb() {
      window.open(this.redirectUrl)
    },
    gotoInfo() {
      window.open(this.redirectUrl + '/user')
    },
    gotoEnt() {
      window.open(this.redirectUrl + '/ent')
    },
    gotoMess() {
      console.log(123)
      window.open(this.redirectUrl + '/message')
    },
    async changeOrganization(id) {
      const res = await changeOrg(id)
      if (res.code === 0) {
        window.location.reload()
      }
    },
    //退出登录
    async handleMenuClick(e) {
      this.visible = false
      const res = await logOut()
      if (res.code === 0) {
        this.$message.success('退出成功!')
        removeToken()
      }
      this.$store.commit('UPDATE_USERINFO', null)
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo || { orgList: [] }
    },
    count() {
      return this.$store.getters.count || 0
    },
    getStyle() {
      return { width: '34px', height: '20px', background: '#FF4D4F', 'border-radius': '10px' }
    },
    redirectUrl() {
      return getProcessEnv() ? 'https://hbtest.gongsibao.com' : 'https://hb.gongsibao.com'
    },
    hbHref() {
      return getRoutePath() + location.href
    }
  },
  components: { Menus }
}
</script>
<style scoped lang="less">
#components-layout-demo-fixed-sider {
  height: 100vh;
  background-color: #fff;
  .layout-header {
    height: 50px;
    line-height: 50px;
    align-items: center;
    padding: 0 20px 0 0;
    .logo {
      width: 200px;
      height: 50px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
      cursor: pointer;
      &.isCollapsed {
        width: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
          margin-right: 0;
        }
      }
      .icon {
        font-size: 32px;
        margin-right: 14px;
      }
      .icon-collapsed {
        font-size: 30px;
      }
      h1 {
        color: #fff;
        overflow: hidden;
        white-space: nowrap;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
    .cr-user {
      height: 100%;
      align-items: center;
      .yf {
        margin-right: 52px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
      .bells {
        margin-right: 51px;
        cursor: pointer;
        .icon {
          font-size: 16px;
        }
      }
      .user-name {
        height: 100%;
        font-weight: 400;
        margin-right: 6px;
        span.tm-fs-ellipsis {
          width: 56px;
          display: inline-block;
          margin-left: 42px;
        }
      }
      .users-box {
        height: 100%;
        min-width: 120px;
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .user {
          cursor: pointer;
          margin-left: 8px;
          width: 40px;
          height: 14px;
          display: flex;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          align-items: center;
          &:nth-child(2) {
            height: 12px;
          }
          .cr-fs-ellipsis {
            margin-right: 5px;
            max-width: 60px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }
          span {
            color: #fff;
            &.user-gs {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.64);
              margin-left: 0;
            }
          }
          //min-width: 90px;
        }
      }
      .submenu {
        background: red;
      }
      a {
        text-decoration: none;
        color: inherit;
      }
      // span {
      //   margin-left: 42px;
      // }
      .span1 {
        font-size: 16px;
      }
      .span2 {
        color: @theme-color;
        cursor: pointer;
      }
      .span3 {
        color: #fff;
        display: inline-block;
        width: 64px;
        line-height: 32px;
        height: 32px;
        margin-top: 16px;
        border-radius: 16px;
        background-color: @theme-color;
        cursor: pointer;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        &:hover {
          opacity: 0.7;
        }
      }
      .message {
        cursor: pointer;
        a {
          display: inline-block;
          vertical-align: middle;
          height: 64px;
          .hb-bell {
            font-size: 24px;
            color: #d6d6d6;
            display: inline-block;
            left: 25px;
          }
        }
      }
      .img {
        cursor: pointer;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        vertical-align: middle;
        .svg-icon {
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          box-sizing: border-box;
        }
      }
    }
  }
  .layout {
    height: calc(100vh - 50px);
    display: flex;
    .layout-sider {
      background-color: #fff;
      position: relative;
      z-index: 99;
      .ant-layout-sider-children {
        margin-top: -0.1px;
        padding-top: 0.1px;
      }
      .ant-layout-footer {
        border-top: 1px solid #f0f0f0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 44px;
        padding: 0 20px;
        background-color: #fff;
        border-right: 1px solid #e8e8e8;
      }
    }
    .layout-content {
      flex: 1;
      box-sizing: border-box;
      margin: 10px;
    }
  }
  .layout-collapsed {
    transition: all 0.2s;
  }
}
@deep: ~'>>>';
@{deep} .super {
  display: inline-block;
  width: 58px !important;
  height: 14px !important;
  // margin-left: 8px;
}
@{deep} .manger {
  display: inline-block;
  width: 38px !important;
  height: 14px !important;
  margin-left: 8px;
}
@{deep} .member {
  display: inline-block;
  width: 28px !important;
  height: 14px !important;
}
.drop-box {
  width: 240px;
  height: 44px;
  // line-height: 37px;
  border-bottom: 1px solid #eee;
  color: #333;
  background: #fff;
  font-size: 14px;
  padding-left: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 4px;
  .borders {
    width: 2px;
    color: #fff;
    line-height: 44px;
    position: absolute;
    left: 0;
    top: 17px;
    height: 15px;
  }
  &:hover {
    background: #f5f8fe;
    color: @theme-color;
    .borders {
      background: @theme-color;
    }
  }
}
@{deep} .ant-scroll-number {
  top: -4px;
  right: 3px;
}
@{deep} .ant-dropdown-menu-item {
  height: 44px;
  line-height: 34px;
  color: #333;
  &:nth-child(1) {
    display: flex;
    background-color: @theme-color;
    // background: url("../../assets/home/back.png") no-repeat;
    // background-size: 100% 100%;
    padding-right: none;
  }
}
@{deep} .ant-dropdown-menu-item-active {
  background: @item-selected;
}
@{deep} .submenu .ant-dropdown-menu-submenu {
  display: flex;
  flex-wrap: nowrap;
}

@{deep} .ant-dropdown-menu-submenu-title {
  height: 44px !important;
  line-height: 34px !important;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:hover {
    background: @item-selected;
  }
}
@{deep} .ant-dropdown-menu-submenu-popup {
  background: chartreuse;
  width: 240px;
  height: 100%;
  margin-left: -165px;
}

.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover {
  background: @item-selected;
}
.ant-dropdown-menu-submenu-title:hover {
  background: @item-selected;
}

.menu-item:hover {
  background: @theme-color !important;
}
.menu-item {
  position: relative;
  .bg {
    top: 0;
    left: 0;
    // right: 0;
    position: absolute;
    width: 110%;
    height: 120%;
  }
}
</style>
